import React, { JSX } from 'react';
import Link from 'next/link';
import { ArrowRightIcon } from 'lucide-react';
import { Box, Button, Icon } from '@chakra-ui/react';

interface PropsInterface {
	children?: React.ReactNode;
	href: string;
	variant?: 'outline';
	showIcon?: boolean;
	icon?: React.ElementType;
	iconPosition?: 'ltr' | 'rtl';
	shadow?: string;
	color?: string;
	hoverScale?: boolean;
	bg?: string;
}

function CtaButton(props: PropsInterface): JSX.Element {
	const buttonStyles =
		props.variant === 'outline'
			? {
					variant: 'outline' as const,
					color: props.color ?? 'primary',
					borderColor: props.color ?? 'primary',
					bg: 'transparent',
					_hover: {
						bg: props.color ?? 'primary',
						color: props.bg ?? 'realWhite',
						...(props.hoverScale && { transform: 'scale(1.05)' }),
					},
			  }
			: {
					bg: props.bg ?? 'primary',
					color: props.color ?? 'realWhite',
					border: 'none',
					_hover: {
						bg: props.bg ? `${props.bg}/90` : 'primary/90',
						...(props.hoverScale && { transform: 'scale(1.05)' }),
					},
			  };

	return (
		<Button
			as={Link}
			//@ts-ignore
			href={props.href}
			py={6}
			fontWeight={600}
			borderRadius={16}
			shadow={props.shadow}
			display="inline-flex"
			alignItems="center"
			flexDirection={props.iconPosition === 'rtl' ? 'row-reverse' : 'row'}
			{...buttonStyles}
		>
			<span>{props.children}</span>

			{props.showIcon && (
				<Box as="span" display="inline-flex" alignItems={'center'} h={'auto'}>
					{props.icon ? <Icon as={props.icon} boxSize={6} /> : <ArrowRightIcon />}
				</Box>
			)}
		</Button>
	);
}

export default CtaButton;
